import type { ProjectScope } from './project-scope';

const pendingPropWriteKeys = new Set<string>();
const pendingPropDeleteKeys = new Set<string>();

function propWriteKey(scope: ProjectScope, propId: string): string {
    return `${scope.orgId}/${scope.projectId}/${propId}`;
}

function propScopePrefix(scope: ProjectScope): string {
    return `${scope.orgId}/${scope.projectId}/`;
}

function propIdFromKey(scope: ProjectScope, key: string): string | null {
    const prefix = propScopePrefix(scope);
    return key.startsWith(prefix) ? key.slice(prefix.length) : null;
}

export function markPendingPropWrite(scope: ProjectScope, propId: string): void {
    pendingPropWriteKeys.add(propWriteKey(scope, propId));
    pendingPropDeleteKeys.delete(propWriteKey(scope, propId));
}

export function clearPendingPropWrite(scope: ProjectScope, propId: string): void {
    pendingPropWriteKeys.delete(propWriteKey(scope, propId));
}

export function isPendingPropWrite(scope: ProjectScope, propId: string): boolean {
    return pendingPropWriteKeys.has(propWriteKey(scope, propId));
}

export function markPendingPropDelete(scope: ProjectScope, propId: string): void {
    pendingPropDeleteKeys.add(propWriteKey(scope, propId));
    pendingPropWriteKeys.delete(propWriteKey(scope, propId));
}

export function clearPendingPropDelete(scope: ProjectScope, propId: string): void {
    pendingPropDeleteKeys.delete(propWriteKey(scope, propId));
}

export function isPendingPropDelete(scope: ProjectScope, propId: string): boolean {
    return pendingPropDeleteKeys.has(propWriteKey(scope, propId));
}

export function clearPendingPropDeletesMissingFromRemote(
    scope: ProjectScope,
    remotePropIds: ReadonlySet<string>
): void {
    for (const key of Array.from(pendingPropDeleteKeys)) {
        const propId = propIdFromKey(scope, key);
        if (propId && !remotePropIds.has(propId)) {
            pendingPropDeleteKeys.delete(key);
        }
    }
}

export function clearPendingPropWrites(): void {
    pendingPropWriteKeys.clear();
    pendingPropDeleteKeys.clear();
}
